import { Link } from "react-router-dom"
import { useContext, useState, useEffect } from "react"
import { DateTime } from "luxon"

import { useQuery } from "@apollo/client"

import ParticipantSidebar from "../../components/sidebars/ParticipantSidebar"
import PageSidebarContent from "../../components/sidebars/PageSidebarContent"

import styles from "../../styles/CustomDataForms.module.css"

import useLabels from "../../hooks/useLabels"

import LoaderMedium from "../../components/Loaders"

import { UserContext } from "../../context/userContext"

import dataParser from "../../helpers/parseJsonData"

import GLOBALS_STATUS from "../../config/globalsStatus"
import _ from "lodash"
import { CUSTOM_FORM_BY_PARTICIPANT } from "./queries"

export default function HepCForm() {
  const [loading, setLoading] = useState(true)
  const [noForm, setNoForm] = useState(false)
  const [data, setData] = useState(null)
  const userCtx = useContext(UserContext)
  const [loadingLabels, labels] = useLabels(["real_d_form"])

  const ID_TEMPLATE = "real_d_form"

  const { refetch } = useQuery(CUSTOM_FORM_BY_PARTICIPANT, {
    variables: {
      participant_id: userCtx.participant_id,
      organization_id: userCtx.session.user.organization_id,
      participant_membership_id: userCtx.participant_membership_id,
      idTemplate: ID_TEMPLATE,
    },
    skip: !userCtx,
    onCompleted: async (data) => {
      if (data.customForm === null) {
        setNoForm(true)
        return setLoading(false)
      }
      const dataFormatted = dataParser(data.customForm.data)
      setData(dataFormatted[0])
      setLoading(false)
    },
  })

  useEffect(() => {
    setLoading(true)
    setData(null)
    setNoForm(false)
    refetch()
  }, [userCtx.current_participant_id, refetch])

  if (loading || loadingLabels) return <LoaderMedium />

  const handleData = () => {
    if (noForm) {
      return (
        <div>
          <h2>No {labels.real_d_form} found for current Participant.</h2>
          <ul className={styles.cta}>
            <li>
              {_.includes(
                GLOBALS_STATUS.ACTIVE_STATUS,
                userCtx.participant_membership_status
              ) ? (
                <Link to={`/form/${ID_TEMPLATE}/1/`} className="btn">
                  New {labels.real_d_form}
                </Link>
              ) : (
                ""
              )}
            </li>
          </ul>
        </div>
      )
    }
    return (
      <div>
        <ul className={styles.cta}>
          <li>
            {_.includes(
              GLOBALS_STATUS.ACTIVE_STATUS,
              userCtx.participant_membership_status
            ) ? (
              <Link
                to={`/form/${ID_TEMPLATE}/1/${data.idStamp}`}
                className="btn"
              >
                Update {labels.real_d_form}
              </Link>
            ) : (
              ""
            )}
          </li>
        </ul>
        <br />
        <div className={styles.table}>
          <div className={styles.tableRow}>
            <div>Form Date: </div>
            <div>{DateTime.fromISO(data.form_date).toISODate()}</div>
          </div>
          <div className={styles.tableRow}>
            <div>American Indian or Alaska Native: </div>
            <div>{data.reald_race_ethnicity_nativeam}</div>
          </div>
          <div className={styles.tableRow}>
            <div>Hispanic or Latino/a: </div>
            <div>{data.reald_race_ethnicity_hisp}</div>
          </div>
          <div className={styles.tableRow}>
            <div>Asian: </div>
            <div>{data.reald_race_ethnicity_asian}</div>
          </div>
          <div className={styles.tableRow}>
            <div>Native Hawaiian or Pacific Islander: </div>
            <div>{data.reald_race_ethnicity_pacific}</div>
          </div>
          <div className={styles.tableRow}>
            <div>Black or African American </div>
            <div>{data.reald_race_ethnicity_afam}</div>
          </div>
          <div className={styles.tableRow}>
            <div>Middle Eastern/Northern African</div>
            <div>{data.reald_race_ethnicity_mideast}</div>
          </div>
          <div className={styles.tableRow}>
            <div>White</div>
            <div>{data.reald_race_ethnicity_white}</div>
          </div>
          <div className={styles.tableRow}>
            <div>Other Categories</div>
            <div>{data.reald_race_ethnicity_other}</div>
          </div>
          <div className={styles.tableRow}>
            <div>Do you speak a language other than English at home?</div>
            <div>{data.reald_language_not_english}</div>
          </div>
          <div className={styles.tableRow}>
            <div>How well do you speak English?</div>
            <div>{data.reald_language_english_proficient}</div>
          </div>
          <div className={styles.tableRow}>
            <div>
              Do you need an interpreter for us to communicate with you?
            </div>
            <div>{data.reald_language_interpreter}</div>
          </div>
          <div className={styles.tableRow}>
            <div>Are you deaf or do you have serious difficulty hearing?</div>
            <div>{data.reald_disability_hearing}</div>
          </div>
          <div className={styles.tableRow}>
            <div>
              Are you blind or do you have serious difficulty seeing, even when
              wearing glasses?
            </div>
            <div>{data.reald_disability_vision}</div>
          </div>
          <div className={styles.tableRow}>
            <div>
              Does a physical, mental, or emotional condition limit your
              activities in any way?
            </div>
            <div>{data.reald_disability_activities}</div>
          </div>
          <div className={styles.tableRow}>
            <div>
              Do you have a serious difficulty walking or climbing stairs?
            </div>
            <div>{data.reald_disability_walking}</div>
          </div>
          <div className={styles.tableRow}>
            <div>Do you have difficulty dressing or bathing?</div>
            <div>{data.reald_disability_dressing}</div>
          </div>
          <div className={styles.tableRow}>
            <div>
              Because of a physical, mental, or emotional condition, do you have
              serious difficulty concentrating, remembering, or making
              decisions?
            </div>
            <div>{data.reald_disability_decisions}</div>
          </div>
          <div className={styles.tableRow}>
            <div>
              Because of a physical, mental, or emotional condition, do you have
              serious difficulty doing errands alone such as visiting a doctor's
              office or shopping?
            </div>
            <div>{data.reald_disability_errands}</div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <>
      <PageSidebarContent>
        <ParticipantSidebar />
      </PageSidebarContent>
      <div className="main-content">
        <h1 className={styles.title}>{labels.real_d_form}</h1>
        <div className={styles.contentWrapper}>{handleData()}</div>
      </div>
    </>
  )
}
